import { UseMutateFunction, useQueryClient } from '@tanstack/react-query';

import { useMutation } from '@hooks/reactQuery';

import { useAppDispatch } from '@store/store';

import { setSnackbar } from '@slices/common';

import { updateConfigurationTemplateNotes } from '@api/configurationTemplates';

import { TConfigurationTemplateUpdateNotesDTO } from '@interfaces/cmModule/dto/configurationTemplatesDTO';

import { ESnackbarTypes, EUserRoles } from '@enums/common';

import { CONFIGURATION_TEMPLATES, CONFIGURATION_TEMPLATES_UPDATE_NOTES  } from '@constants/queryKeys';
import { responseMessages } from '@constants/responseMessages';

interface IUseMutateConfigurationTemplateUpdateNotesReturned {
	isLoadingUpdateNotes: boolean;
	updateNotes: UseMutateFunction<any, any, TConfigurationTemplateUpdateNotesDTO, any>;
}

const useMutateConfigurationTemplateUpdateNotes = (): IUseMutateConfigurationTemplateUpdateNotesReturned => {
	const queryClient = useQueryClient();
	const dispatch = useAppDispatch();

	const {
		mutateAsync,
		isLoading,
	} = useMutation<TConfigurationTemplateUpdateNotesDTO>({
		mutationKey: [CONFIGURATION_TEMPLATES_UPDATE_NOTES],
		mutationFn: updateConfigurationTemplateNotes,
		onSuccess: () => {
			dispatch(setSnackbar({
				message: responseMessages.updateTemplateNotes,
				type: ESnackbarTypes.success,
			}));

			return queryClient.invalidateQueries([CONFIGURATION_TEMPLATES]);
		},
		allowedRoles: [
			EUserRoles.networkOperatorCmModuleEditor,
			EUserRoles.networkOperatorCmModuleAdmin,
		],
	});

	return {
		isLoadingUpdateNotes: isLoading,
		updateNotes: mutateAsync,
	};
};

export default useMutateConfigurationTemplateUpdateNotes;
